<div class="aii">

  <!-- Header -->
  <div class="aii__head">
    <div class="aii__head-left">
      <span class="aii__robot">🤖</span>
      <span class="aii__title">AI Insights</span>
      <span class="aii__badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
    </div>
    <div class="aii__head-right">
      <button class="aii__btn"
              (click)="markAllRead()"
              [disabled]="markingAll || unreadCount === 0"
              title="Mark all as read">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <path d="M20 6L9 17L4 12" stroke="currentColor"
                stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
        All read
      </button>
      <button class="aii__btn aii__btn--teal"
              (click)="runNow()"
              [disabled]="runningCheck"
              title="Run checks now">
        <span class="aii__spin" *ngIf="runningCheck"></span>
        <svg *ngIf="!runningCheck" width="12" height="12"
             viewBox="0 0 24 24" fill="none">
          <path d="M3 12C3 7 7 3 12 3s9 4 9 9-4 9-9 9"
                stroke="currentColor" stroke-width="2"
                stroke-linecap="round"/>
          <polyline points="20.5 3 20.5 8 15.5 8"
                    stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ runningCheck ? 'Checking…' : 'Run now' }}
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div class="panel__loading" *ngIf="loading">
    <div class="spinner"></div>
    <span>Analysing field data…</span>
  </div>

  <!-- List -->
  <div class="aii__list" *ngIf="!loading">

    <!-- Empty -->
    <div class="panel__empty" *ngIf="insights.length === 0">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
        <path d="M8 12a4 4 0 018 0" stroke="currentColor"
              stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="12" cy="12" r="1" fill="currentColor"/>
      </svg>
      <p>No insights yet — AI monitoring is active.</p>
      <small>Checks run automatically every 10 minutes.</small>
    </div>

    <!-- Cards -->
    <div
      *ngFor="let insight of insights; trackBy: trackById"
      class="aii__card"
      [ngClass]="severityClass(insight.severity)"
      [class.aii__card--unread]="!insight.isRead"
      (click)="markAsRead(insight, $event)">

      <!-- Top row -->
      <div class="aii__card-top">
        <div class="aii__card-left">
          <span class="aii__type-icon">{{ typeIcon(insight.type) }}</span>
          <div class="aii__card-meta">
            <span class="aii__type-lbl">{{ typeLabel(insight.type) }}</span>
            <span class="aii__sev"
                  [class.aii__sev--high]="insight.severity === 'High'"
                  [class.aii__sev--med]="insight.severity === 'Medium'"
                  [class.aii__sev--low]="insight.severity === 'Low'">
              {{ severityIcon(insight.severity) }} {{ insight.severity }}
            </span>
          </div>
        </div>
        <div class="aii__card-actions">
          <span class="aii__dot" *ngIf="!insight.isRead"></span>
          <button class="aii__dismiss"
                  (click)="dismiss(insight, $event)"
                  title="Dismiss">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Message -->
      <p class="aii__msg">{{ insight.message }}</p>

      <!-- Tags -->
      <div class="aii__tags">
        <span class="aii__tag aii__tag--job" *ngIf="insight.relatedJobTitle">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="7" width="20" height="14" rx="2"
                  stroke="currentColor" stroke-width="2"/>
            <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"
                  stroke="currentColor" stroke-width="2"
                  stroke-linecap="round"/>
          </svg>
          {{ insight.relatedJobTitle }}
        </span>
        <span class="aii__tag aii__tag--worker" *ngIf="insight.relatedWorkerName">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
            <path d="M4 20c0-3 3.6-6 8-6" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round"/>
          </svg>
          {{ insight.relatedWorkerName }}
        </span>
        <span class="aii__tag aii__tag--time">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 7v5l3 2" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round"/>
          </svg>
          {{ insight.createdAt | date:'dd MMM, HH:mm' }}
        </span>
      </div>

    </div>

  </div>
</div>